import store from '@/store';
import { log } from '@/utils/common';
import compositionHelpers from '@/utils/helpers/composition';
import { http } from '../utils/http';
import orderApi from '@/apis/order'

export default {

    async getPagedOrderInfo(packName = '', page = '1', userStatus = '', purchase_type = '') {
        try {
            const ssoToken = store.getters["ssoToken"]
            const { results } = await http.post('/order/list', {
                search_type: 'L',
                abo_no: store.getters.userId,
                cuid: store.getters.cuid,
                order_no: '',
                user_status: userStatus,
                mypack_name: packName,
                page_number: page,
                purchase_type: purchase_type,
            }, {
                "Sso-Token": ssoToken
            });
            const arr = results.order_list.map((n) => ({
                orderKey: n.order_key,
                mypackName: n.mypack_name,
                reqDate: n.re_reg_date,
                reqNo: n.req_no,
                curSeq: n.cur_seq,
                orderCode: n.order_code,
                reOrderble: n.reOrderble,
                applyNo: n.apply_no,
                abcCode: n.abc_cd,
                abcName: n.abc_name,
                cfmKind: n.cfm_kind,
                packStatus: n.pack_status,
                orderStatus: n.order_status,
                userStatus: n.user_status,
                userStatusName: n.user_status_name,
                purchaseType: n.purchase_type,
                billingPeriod: n.billing_period,
                consulted: n.consulted,
                paymentType: n.payment_type,
            }));
            return {
                packList: arr,
                totalCount: results.order_count,
            };
        } catch (e) {
            console.log(e);
            store.dispatch('newError', {
                msg: '마이팩 목록 정보를 가져올 수 없습니다. 잠시 후 다시 시도해 주세요.',
                error: e,
            });
            return {
                packList: [],
                totalCount: 0,
            };
        }
    },

    async postCompleteAppliance(data) {
        try {
            const { result } = await http.post('/order/pack', {
                mypack_name: data.packName,
                abo_no: store.getters.userId,
                cuid: store.getters.cuid,
                take_days: data.takeDays,
                order_type: '',
                abc_cd: data.abcCd,
                total_price: data.totalPrice,
                total_pv: data.totalPv,
                total_bv: data.totalBv,
                gender: store.getters['agreement/targetSex'],
                age_group: store.getters['agreement/targetRange'],
                intaker: store.getters['agreement/targetIntaker'],
                detail: data.detail.map((n) => ({
                    ...n,
                    dose: data.dose,
                })),
                req_no: (data.reorder ? data.reqNo : ''),
                cfm_kind: data.cfm_kind,

                purchase_type: data.purchaseType,
                receive_phone: data.receivePhone,
                delivery_address: data.deliveryAddress,
                delivery_message: data.deliveryMessage,
                billing_date: data.billingDate,
                billing_status: data.billingStatus,
                payment: {
                    'payment_mode': data.paymentInfo.paymentMode,
                    'payment_code': data.paymentInfo.paymentCode,
                    'customer_id': data.paymentInfo.customerId,
                    'issuer_code': data.paymentInfo.issuerCode,
                    'issuer_name': data.paymentInfo.issuerName,
                    'installment_plan': data.paymentInfo.installmentPlan,
                    'receipt_type': data.paymentInfo.receiptType,
                    'receipt_issuance_type': data.paymentInfo.receiptIssuanceType,
                    'receipt_number_type': data.paymentInfo.receiptNumberType,
                    'receipt_issuance_number': data.paymentInfo.receiptIssuanceNumber,
                },
                reorder: data.reorder || false,
                consultation: data.consultation || false,
                payment_type: data.paymentType
            });
            log('pack::postCompleteAppliance', result);
            return result;
        } catch (e) {
            store.dispatch('newError', {
                msg: '마이팩 신청 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
                error: e,
            });
            return {
                error: e,
            };
        }
    },

    async getApplianceDetail(data, includePayment = false) {
        // 팩 Detail 조회.
        try {
            let orderToken = orderToken = await orderApi.getOrderToken(Number(data), false, null)
            store.commit("order/updateOrderToken", orderToken)

            const ssoToken = store.getters["ssoToken"]
            const { results } = await http.post('/order/list', {
                search_type: 'D',
                abo_no: store.getters.userId,
                cuid: store.getters.cuid,
                order_no: data,
                includePayment: includePayment,
            }, {
                "Order-Token": orderToken,
                "Sso-Token": ssoToken
            });

            const products = store.getters['product/products'];
            results.order_detail_list.forEach((m, idx) => {
                products.forEach((n) => {
                    if (n.item_sku === m.item_sku) {
                        results.order_detail_list[idx].seq = n.seq;
                    }
                });
            });

            results.order_detail_list.sort((a, b) => a.seq - b.seq);

            return results;
        } catch (e) {
            store.dispatch('newError', {
                msg: '마이팩 상세 정보를 가져올 수 없습니다. 잠시 후 다시 시도해 주세요.',
                error: e,
            });
            return {
                error: e,
            };
        }
    },
    // 주문서 상세 정보 조회 - 그룹오더용
    async getApplianceDetailForGroup(reqNos) {
        try {
            const ssoToken = store.getters["ssoToken"]
            let orderToken = store.getters["order/orderToken"]

            if (orderToken === '' || orderToken === undefined || orderToken === null) {
                orderToken = await orderApi.getOrderToken(reqNos[0], true, reqNos.map((reqNo) => ({ req_no: reqNo })))
                store.commit("order/updateOrderToken", orderToken)
            }

            const { results } = await http.post('/order/list', {
                search_type: 'GD',
                abo_no: store.getters.userId,
                cuid: store.getters.cuid,
                order_no: reqNos,
                status: '',
                mypack_name: '',
                page_number: '',
            }, {
                "Order-Token": orderToken,
                "Sso-Token": ssoToken,
            });

            const products = store.getters['product/products'];
            results.forEach((item) => {
                item.order_detail_list.forEach((m, idx) => {
                    products.forEach((n) => {
                        if (n.item_sku === m.item_sku) {
                            item.order_detail_list[idx].seq = n.seq;
                        }
                    });
                });
                item.order_detail_list.sort((a, b) => a.seq - b.seq);
            });
            return results;
        } catch (e) {
            store.dispatch('newError', {
                msg: '마이팩 상세 정보를 가져올 수 없습니다. 잠시 후 다시 시도해 주세요.',
                error: e,
            });
            return {
                error: e,
            };
        }
    },
    async updateCompleteAppliance(data) {
        try {
            const { result } = await http.post('/order/pack', {
                mypack_name: data.packName,
                abo_no: store.getters.userId,
                cuid: store.getters.cuid,
                take_days: data.takeDays,
                order_type: '',
                abc_cd: data.abcCd,
                total_price: data.totalPrice,
                total_pv: data.totalPv,
                total_bv: data.totalBv,
                gender: '',
                age_group: '',
                intaker: '',
                detail: data.detail.map((n) => ({
                    ...n,
                    dose: data.dose,
                })),
                req_no: data.reqNo,
                cfm_kind: data.cfm_kind,

                purchase_type: data.purchaseType,
                receive_phone: data.receivePhone,
                delivery_address: data.deliveryAddress,
                delivery_message: data.deliveryMessage,
                billing_date: data.billingDate,
                billing_status: data.billingStatus,
                payment: {
                    'payment_mode': data.paymentInfo.paymentMode,
                    'payment_code': data.paymentInfo.paymentCode,
                    'customer_id': data.paymentInfo.customerId,
                    'issuer_code': data.paymentInfo.issuerCode,
                    'issuer_name': data.paymentInfo.issuerName,
                    'installment_plan': data.paymentInfo.installmentPlan,
                    'receipt_type': data.paymentInfo.receiptType,
                    'receipt_issuance_type': data.paymentInfo.receiptIssuanceType,
                    'receipt_number_type': data.paymentInfo.receiptNumberType,
                    'receipt_issuance_number': data.paymentInfo.receiptIssuanceNumber,
                },
            });
            return result;
        } catch (e) {
            store.dispatch('newError', {
                msg: '마이팩 신청 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
                error: e,
            });
            return {
                error: e,
            };
        }
    },
    async cancelConsultationApplied(data) {
        try {
            const ssoToken = store.getters["ssoToken"]
            const headers = {
                "Sso-Token": ssoToken
            }
            const result = await http.post('/order/cancel', {
                search_type: 'R',
                req_no: data,
                cuid: store.getters.cuid,
            }, headers);
            return result;
        } catch (e) {
            store.dispatch('newError', {
                msg: '마이팩 신청 취소 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
                error: e,
            });
            return '';
        }
    },

    async doNothing() {
        return new Promise((resolve) => {
            store.dispatch('showSpinner');
            setTimeout(() => {
                store.dispatch('hideSpinner');
                resolve();
            }, 800);
        });
    },

    async setRecompositionContextFromMypack(reqNo, packName) {
        const r = await this.getApplianceDetail(reqNo);
        if (r.error) {
            return;
        }

        const selectedSkus = r.order_detail_list.map((n) => {
            const count = n.dose_list
                .split(',')
                .reduce((acc, x) => acc + parseInt(x, 10), 0);
            return {
                item_sku: n.item_sku,
                count,
            };
        });

        compositionHelpers.createRecompositionWithReqNoContext(selectedSkus, packName);
    },
    async deleteSelectedMypacks(reqNoGroup) {
        try {
            const ssoToken = store.getters["ssoToken"]
            const headers = {
                "Sso-Token": ssoToken
            }
            const result = await http.post('/order/cancel', {
                search_type: 'D',
                req_no: reqNoGroup,
                abo_no: store.getters.userId,
                cuid: store.getters.cuid,
            }, headers);
            return result;
        } catch (e) {
            store.dispatch('newError', {
                msg: '마이팩 삭제 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
                error: e,
            });
            return {
                error: 'error',
            };
        }
    },
    async checkPackOrderLimit() {
        await this.checkLogin();
        try {
            const result = await http.post('/abo-info', {
                search_type: 'C',
            });
            return result.result;
        } catch (e) {
            store.dispatch('newError', {
                msg: '신청서 조회 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
                error: e,
            });
            return {
                error: 'error',
            };
        }
    },
    async changePackName(reqNo, packName) {
        try {
            const result = await http.post('/abo-info', {
                search_type: 'AP',
                mypack_name: packName,
                req_no: reqNo,
            });
            return result.result;
        } catch (e) {
            store.dispatch('newError', {
                msg: '팩 이름 변경 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
                error: e,
            });
            return {
                error: 'error',
            };
        }
    },
    async changeABCLocation(reqNo, abcLocation) {
        try {
            const result = await http.post('/abo-info', {
                search_type: 'AP',
                abc_cd: abcLocation,
                req_no: reqNo,
            });
            return result.result;
        } catch (e) {
            store.dispatch('newError', {
                msg: '신청 ABC 변경 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
                error: e,
            });
            return {
                error: 'error',
            };
        }
    },

    async confirmConsultation(req_no, fail_reason = "") {
        try {
            const { result } = await http.post("/abo-info", {
                search_type: "S",
                req_no: req_no,
                status: "C",
                fail_reason: fail_reason,
            });
            log("confirmConsultation", result);
            return result;
        } catch (e) {
            store.dispatch("newError", {
                msg: "정기구매 간편상담 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
                error: e,
            });
            return {
                error: e,
            };
        }
    },

    async updatePackDeliveryAddress(req_no, deliveryAddressId) {
        try {
            const { result } = await http.post("/abo-info", {
                search_type: "LD",
                req_no: req_no,
                delivery_address: deliveryAddressId,
            });
            log("confirmConsultation", result);
            return result;
        } catch (e) {
            store.dispatch("newError", {
                msg: "배송지 변경 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
                error: e,
            });
            return {
                error: e,
            };
        }
    },

    async cancelPackRecurringThisMonth(req_no) {
        try {
            const { result } = await http.post("/abo-info", {
                search_type: "R",
                req_no: req_no,
                fail_reason: "TNA",
            });
            log("confirmConsultation", result);
            return result;
        } catch (e) {
            store.dispatch("newError", {
                msg: "정기구매 주문 취소 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
                error: e,
            });
            return {
                error: e,
            };
        }
    },

    async checkLogin() {
        if (!store.state.isLogin) {
            await store.dispatch('ssoLogin');
            await store.dispatch("ssoToken");
        }
    }
};
